/* eslint-disable no-plusplus */
import { MutableRefObject } from "react";

export interface IItemDimensions {
  width: number;
  height: number;
}

/**
 *
 * @param element target DOM element
 * @returns  element dimension obj (width and height)
 * including margins
 */
export const getOuterDimensions = (element: HTMLElement): IItemDimensions => {
  if (!element)
    return {
      width: 0,
      height: 0,
    };
  const elementStyles = getComputedStyle(element);

  return {
    width:
      element.getBoundingClientRect().width +
      parseFloat(elementStyles.marginLeft) +
      parseFloat(elementStyles.marginRight),
    height:
      element.getBoundingClientRect().height +
      parseFloat(elementStyles.marginTop) +
      parseFloat(elementStyles.marginBottom),
  };
};

export const getInnerDimensions = (element: HTMLElement): IItemDimensions => {
  if (!element)
    return {
      width: 0,
      height: 0,
    };
  const elementStyles = getComputedStyle(element);

  return {
    width:
      element.getBoundingClientRect().width -
      parseFloat(elementStyles.paddingLeft) -
      parseFloat(elementStyles.paddingRight) -
      parseFloat(elementStyles.borderWidth),
    height:
      element.getBoundingClientRect().height -
      parseFloat(elementStyles.paddingTop) -
      parseFloat(elementStyles.paddingBottom) -
      parseFloat(elementStyles.borderWidth),
  };
};

/**
 *
 * @param dimensionArray array of elements dimensions
 * @param availableSpace dimension of container
 * @returns number of elements that fits into container
 */
export const maxItemsFit = (
  dimensionArray: IItemDimensions[],
  availableSpace: number,
): number => {
  let currentTakenSpace = 0;
  let displayItemsCounter = 0;

  dimensionArray.some((item) => {
    currentTakenSpace += item.width;
    if (currentTakenSpace >= availableSpace) {
      return true;
    }
    displayItemsCounter++;
    return false;
  });

  return displayItemsCounter;
};

export const getDimensions = (
  container: MutableRefObject<HTMLDivElement>,
  childrenLength: number,
): IItemDimensions[] => {
  const dimensions: IItemDimensions[] = [];

  const childrenList = container?.current?.children;

  [...(childrenList as unknown as Array<any>)].forEach((child: HTMLElement) => {
    dimensions.push(getOuterDimensions(child));
  });

  return dimensions.splice(0, childrenLength);
};
